import { render, staticRenderFns } from "./articulo.vue?vue&type=template&id=0b7b0263&scoped=true&"
import script from "./articulo.vue?vue&type=script&lang=ts&"
export * from "./articulo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b0263",
  null
  
)

export default component.exports